import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  containerFormControlFirst: {
    display: "flex",
    alignItems: "center",
  },
  formControlFirst: {
    margin: theme.spacing(1),
    minWidth: 152,
    height: 48,
    backgroundColor: "rgba(27, 39, 71, 0.4)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    borderRadius: 4,
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& .MuiSelect-select": {
      color: "#FFFFFF",
      fontFamily: "MontserratRegular",
      fontSize: 18,
      padding: "0 32px 0 16px !important",
      display: "flex",
      alignItems: "center",
      height: "100%",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiSelect-icon": {
      color: "#06E89F",
      fontSize: "20px",
      top: "calc(50% - 10px)",
      right: 8,
    },
    "&:hover": {
      backgroundColor: "rgba(27, 39, 71, 0.6)",
      border: "1px solid rgba(255, 255, 255, 0.2)",
    },
  },

  containerTextFormControlFirst: {
    height: "100%",
    display: "flex",
    "@media screen and (min-width:576px)": {
      alignItems: "center",
    },
    "@media screen and (max-width:992px)": {
      alignItems: "center",
    },
  },

  formControlSecond: {
    margin: theme.spacing(1),
    minWidth: 152,
    height: 48,
    backgroundColor: "rgba(27, 39, 71, 0.6)",
    border: "1px solid #06E89F",
    borderRadius: 4,
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& .MuiSelect-select": {
      color: "#06E89F",
      fontFamily: "MontserratRegular",
      fontSize: 18,
      padding: "0 32px 0 16px !important",
      display: "flex",
      alignItems: "center",
      height: "100%",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiSelect-icon": {
      color: "#06E89F",
      fontSize: "20px",
      top: "calc(50% - 10px)",
      right: 8,
    },
    "&:hover": {
      boxShadow: "0 0 10px rgba(6, 232, 159, 0.3)",
      backgroundColor: "rgba(27, 39, 71, 0.8)",
    },
  },

  textFormControlFirst: {
    color: theme.palette.text.selectProjects,
    fontSize: 14,
    fontFamily: "MontserratRegular",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  selectContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: 15,
    marginBottom: 45,
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
  },
  contentProjectCard: {
    marginBottom: "10px",
  },

  searchContainer: {
    marginBottom: 24,
    width: "100%",
  },
  searchInput: {
    width: "100%",
    height: 48,
    backgroundColor: "rgba(27, 39, 71, 0.4)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    borderRadius: 4,
    padding: "0 16px",
    color: "#FFFFFF",
    fontFamily: "MontserratRegular",
    fontSize: 16,
    display: "flex",
    alignItems: "center",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(27, 39, 71, 0.6)",
      border: "1px solid rgba(255, 255, 255, 0.2)",
    },
    "&.Mui-focused": {
      border: "1px solid #06E89F",
      boxShadow: "0 0 8px rgba(6, 232, 159, 0.2)",
    },
    "& input": {
      color: "#FFFFFF",
      fontFamily: "MontserratRegular",
      fontSize: 16,
      "&::placeholder": {
        color: "rgba(255, 255, 255, 0.4)",
        opacity: 1,
      },
    },
    "& .MuiInputAdornment-root": {
      color: "rgba(255, 255, 255, 0.4)",
    },
    "&.Mui-focused .MuiInputAdornment-root": {
      color: "#06E89F",
    },
  },

  menuProps: {
    "& .MuiPaper-root": {
      backgroundColor: "#0C1839",
      borderRadius: "12px",
      marginTop: "8px",
      border: "1px solid rgba(255, 255, 255, 0.1)",
      boxShadow: "0px 10px 20px rgba(0,0,0,0.5)",
    },
    "& .MuiList-root": {
      padding: "8px 0",
    },

    "& .MuiMenuItem-root": {
      fontFamily: "MontserratRegular",
      fontSize: "14px",
      color: "#FFFFFF",
      padding: "12px 20px",
      transition: "all 0.2s ease",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",

      "&:hover": {
        backgroundColor: "rgba(6, 232, 159, 0.1)",
      },

      "&.Mui-selected": {
        backgroundColor: "transparent",
        color: "#06E89F",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "rgba(6, 232, 159, 0.1)",
        },
      },
    },
  },
}));

export default useStyles;
